export class OrderByField {
    tableAlias: string;
    fieldName: string;
    sufix: string;

    constructor( tableAlias: string, fieldName: string, sufix: string ) {
        this.tableAlias = tableAlias;
        this.fieldName = fieldName;
        this.sufix = sufix;
    }
}
